<!--
 * @Description: 
 * @Author: WangYuhan
 * @Date: 2022-11-01 16:43:01
 * @LastEditTime: 2023-12-11 14:56:27
 * @LastEditors: WangYuhan
-->
<template>
  <div class="loadings">
    <div class="loading"></div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.loadings {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 5000;
  .loading {
    width: 48px;
    height: 48px;
    border-width: 3px;
    border-style: dashed solid solid dotted;
    border-color: #212220 #212220 transparent #212220;
    border-radius: 50%;
    display: inline-block;
    position: relative;
    top: 40%;
    left: 50%;
    margin-left: -24px;
    animation: rotation 1s linear infinite;
  }

  .loading:after {
    content: '';
    position: absolute;
    left: 20px;
    top: 30px;
    border: 10px solid transparent;
    border-right-color: #212220;
    transform: rotate(-40deg);
  }
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
.loading {
  zoom: 2;
}
</style>
